import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { uploaded_assessment_loading : true, uploaded_assessment_data: '', uploaded_assessment_error_data : '', uploaded_assessment_error: false};

export function uploadAssessment(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_UPLOAD_ASSESSMENT_API:
        return {
            uploaded_assessment_loading: true,
            uploaded_assessment_data: '',
            uploaded_assessment_error_data: '',
            uploaded_assessment_error: false
        };
      case organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_API:
        return {
            uploaded_assessment_loading: false,
            uploaded_assessment_data: action.uploaded_assessment.data,
            uploaded_assessment_error_data: '',
            uploaded_assessment_error: false
        };
      case organisationConstants.ERROR_UPLOAD_ASSESSMENT_API:
        return { 
            uploaded_assessment_loading: false,
            uploaded_assessment_data: '',
            uploaded_assessment_error_data: action.error.response.data.message,
            uploaded_assessment_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/uploadCsv/uploadAssessment.reducer.js